import axiosLoadingClient from "axios";
import { installDataLoading } from "../../shared/xproject-loading";
import "../../shared/xproject-loading.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import nameParse from './store/name-parse';

import moment from 'moment';
import VShowSlide from 'v-show-slide'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VShowSlide)
Vue.prototype.$moment = moment; //赋值使用

Vue.prototype.$nameParse= nameParse;
// Vue.prototype.$THREE = THREE;
Vue.config.productionTip = false;
installDataLoading(Vue, router, axiosLoadingClient);
import {
	numberToCurrencyNo
} from './utils/numberToCurrency.js'
// 配置全局过滤器，实现数字千分位格式
Vue.filter('numberToCurrency', numberToCurrencyNo)
// 引入页面scss
import './style/style.scss';

// 引入iconfont
import './assets/iconfont/iconfont.css';

// 引入 Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入 BootstrapVue
import {
	BootstrapVue
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin


// 引入移动端分页样式方法
import mobilePage from './utils/mobilePageStyle.js'
Vue.prototype.mp = mobilePage;

// 引入vue-i18-语言切换
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'zh', // 语言标识
	messages: {
		'zh': require('./language/china'),
		'en': require('./language/english')
	}
});

// 引用 cytoscape


// 引用 axios
import axios from 'axios'
Vue.prototype.$linkage = axios;

// 引入 HTML转换PDF插件
import htmlToPdf from './api/htmlToPdf'
Vue.use(htmlToPdf)


/**
 *  qs 
 *  qs.stringify()  转换成查询字符串 
 *  qs.parse() 转换成json对象
 */
import qs from 'qs'
Vue.prototype.qs = qs;

// 引用API文件
import url from './api/api.js';
import root from './api/axios.js';
// 将API方法绑定到全局
Vue.prototype.$http = url;
Vue.prototype.$rooturl = root;

// 引入企业微信配置js
import qyvxConfig from './static/js/qyvx_config.js';
Vue.prototype.$qyvxConfig = qyvxConfig;

// 实时接收消息推送
Vue.prototype.resetSerItem = function (key, newValue) {
	if (key === 'watchStorage') {
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				localStorage.setItem(k, val);

				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

				window.dispatchEvent(newStorageEvent);
			}
		}
		return storage.setItem(key, newValue);
	}
}

// 引用WebSocket文件
import WebSocket from './api/WebSocket.js';
// 将WebSocket方法绑定到全局
Vue.prototype.$WebSocket = WebSocket;

//引用mixin
import mixin from './static/js/mixin.js';
Vue.mixin(mixin);



// main.js（每页显示不同的标题）
router.beforeEach((to, from, next) => {

	// if (to.path == '/board_detail_info?id=c1c31c73fe7345d3af2e8ef7a4d56024&taskBoardId=e53f6fbd66b54d179850d72b9e8f53f4&tztype=1') {
	// 	// window.location.href = 'https://www.baidu.com/';

	// }
	if (
		to.path != '/Login'
		&& to.path != '/wxLogin'
		&& to.path != '/qyvxLogin'
		&& to.path != '/'
		&& to.path != '/download'
		&& to.path != '/solution'
		&& to.path != '/solution2'
		&& to.path != '/solution3'
		&& to.path != '/solution4'
		&& to.path != '/projectprice'
		&& to.path != '/helpcenter'
		&& to.path != '/updatelog'
		&& to.path != '/projectindex'
		&& to.path != '/companyinvite'
		&& to.path != '/register'
		&& to.path != '/registerAgreement'
		&& to.path != '/forget_password'
		&& to.path != '/forget_pw'
		&& to.path != '/bindQyvx'
		&& to.path != '/helpcenter'
		&& to.path != '/bindWx'
		&& to.path != '/project_view_board'
	) {
		localStorage.setItem('currentPage2', to.path);
		localStorage.setItem("currentPage3", JSON.stringify(to.query));
	}
    if (to.meta.content) {
        ['keywords','description'].forEach(name => {
            const content = to.meta.content[name];
            if (!content) return;
            let tag = document.querySelector('meta[name="'+name+'"]');
            if (!tag) {tag = document.createElement('meta');tag.name = name;document.head.appendChild(tag);}
            tag.content = content;
        });
    }
	// to来自  from  去哪
	if (to.meta.title) {
		document.title = to.meta.title
	}
	if (to.path == '/board_detail_info' && (from.path == '/project_task' || from.path == '/project_task1' || from.path == '/my_task')) {
		from.meta.keepAlive = true;
	} else if (localStorage.getItem('bindDelete') == 1) {
		localStorage.setItem('bindDelete', 0)
		to.meta.keepAlive = false;

	} else {
		from.meta.keepAlive = false;
	}
	if ((to.path == "/index" || to.path == "/management") && (localStorage.getItem("companyId") != "" && localStorage.getItem("companyId") != undefined)) {
		localStorage.setItem("ismanagement", 1);
	} else {
		localStorage.removeItem('ismanagement');
	}
	// if(from.path == 'history_message' && to.query.curpage){

	// }
	if (!(to.path == 'history_message' && from.path == 'message_detail')) {
		localStorage.removeItem('curpage');
	}
	next()
})


// 引用复制功能
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 路由跳转时定位到页面顶部
// router.beforeEach((to, from, next) => {    
// 	// chrome
// 	document.body.scrollTop = 0
// 	// firefox
// 	document.documentElement.scrollTop = 0
// 	// safari
// 	window.pageYOffset = 0
// 	next()
// })



import '../../shared/xproject-ui.css';
import './style/xproject-client.css';
import ClientPageHeading from './components/ClientPageHeading.vue';
Vue.component('ClientPageHeading', ClientPageHeading);
import '../../shared/xproject-controls.css';
import './style/client-workspace.css';
import './style/client-detail.css';

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount("#app");
try {
  document.documentElement.classList.toggle('xp-comfortable', localStorage.getItem('xp-client-comfortable') === 'true');
  document.documentElement.classList.toggle('xp-reduced-motion', localStorage.getItem('xp-client-reduced-motion') === 'true');
} catch (error) { /* Browser storage may be unavailable. */ }
